const adsEnabled = process.env.REACT_APP_ADS_ENABLED === 'true';

export default function AdSlot({ slot = 'in-article', label = 'Advertisement' }) {
  if (!adsEnabled) return null;

  return (
    <aside className={`ad-slot ad-slot--${slot}`} aria-label={label}>
      <span>{label}</span>
      <div className="ad-slot__canvas" data-ad-client={process.env.REACT_APP_ADSENSE_CLIENT_ID || ''} data-ad-slot={process.env.REACT_APP_ADSENSE_SLOT_ID || ''} />
    </aside>
  );
}